import {
    CORE_GET_ALL_DOMAIN_REQUEST,
    CORE_GET_ALL_DOMAIN_SUCCESS,
    CORE_GET_ALL_DOMAIN_FAILURE,
    CORE_GET_DOMAIN_ID_REQUEST,
    CORE_GET_DOMAIN_ID_SUCCESS,
    CORE_GET_DOMAIN_ID_FAILURE,
    REQUEST_STATE
} from '../types';

const requestState = REQUEST_STATE;

export default {
    allDomain: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_DOMAIN_REQUEST:
                return state;
            case CORE_GET_ALL_DOMAIN_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case CORE_GET_ALL_DOMAIN_FAILURE:
                return [];
            default:
                return state;
        }
    },
    domainById: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_DOMAIN_ID_REQUEST:
                return state;
            case CORE_GET_DOMAIN_ID_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === 'object') {
                    const { result, data } = action.payload;
                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case CORE_GET_DOMAIN_ID_FAILURE:
                return {};
            default:
                return state;
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/redux/reducers/domain.js